module.exports = __webpack_public_path__ + "3d368c34e16a21bb92126444182b6206.png";